/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import './PlayerLauncher.scss';
import { getTabSpecificData, setTabSpecificData } from 'src/utils/sessionHelper';
import { getEnvironmentUrls } from 'src/services/urls';

function PlayerLauncher() {
	const [token, setToken] = useState('');
	const [readerVersion, setReaderVersion] = useState('');
	const [ctkUrl, setCtkUrl] = useState(getEnvironmentUrls().ctkUrl || '');
	const [display, setDisplay] = useState('');
	const [showLogoutButton, setShowLogoutButton] = useState(true);
	const [isLoading, setIsLoading] = useState(false);
	const history = useHistory();

	useEffect(() => {
		const existingToken = getTabSpecificData('ctkToken');
		const existingUrl = getTabSpecificData('ctkUrl');
		const existingDisplay = getTabSpecificData('display');
		const existingReaderVersion = getTabSpecificData('readerVersion');
		const existingShowLogoutButton = getTabSpecificData('showLogoutButton');

		setToken(existingToken || '');
		setCtkUrl(existingUrl || getEnvironmentUrls().ctkUrl);
		setDisplay(existingDisplay || '');
		setReaderVersion(existingReaderVersion || '');
		setShowLogoutButton(existingShowLogoutButton ? existingShowLogoutButton === 'true' : true);

		setIsLoading(false);
	}, []);

	const handleLaunch = () => {
		setIsLoading(true);

		setTabSpecificData('ctkToken', token.trim());
		setTabSpecificData('ctkUrl', ctkUrl.trim());
		setTabSpecificData('display', display.trim());
		setTabSpecificData('readerVersion', readerVersion);
		setTabSpecificData('showLogoutButton', String(showLogoutButton));

		history.push('/player', {
			ctkToken: token.trim(),
			ctkUrl: ctkUrl.trim() || getEnvironmentUrls().ctkUrl,
			display: display.trim(),
			readerVersion,
			showLogoutButton,
		});
	};

	return (
		<div className="player-launcher-container">
			<div className="player-launcher-card">
				<h3>AT Student UI</h3>

				<div className="form-group">
					<label htmlFor="token">Token *</label>
					<textarea
						id="token"
						value={token}
						onChange={(e) => setToken(e.target.value)}
						placeholder="Enter your JWT token here..."
						rows={6}
						className="token-input"
						disabled={isLoading}
					/>
				</div>

				<div className="form-group">
					<label htmlFor="ctkUrl">CTK URL (Optional)</label>
					<input
						id="ctkUrl"
						type="text"
						value={ctkUrl}
						onChange={(e) => setCtkUrl(e.target.value)}
						placeholder="Custom CTK URL"
						disabled={isLoading}
					/>
				</div>

				<div className="form-group">
					<label htmlFor="display">Display Mode (Optional)</label>
					<select
						id="display"
						value={display}
						onChange={(e) => setDisplay(e.target.value)}
						disabled={isLoading}
					>
						<option value="">Default - EdgeEx</option>
						<option value="k2">Grade K2</option>
						<option value="3-5">Grade 3-5</option>
					</select>
				</div>

				<div className="form-group">
					<label htmlFor="readerVersion">Reader Version (Optional)</label>
					<input
						id="readerVersion"
						type="text"
						value={readerVersion}
						onChange={(e) => setReaderVersion(e.target.value)}
						placeholder="e.g. xxxx.x.x-xxxxx"
						disabled={isLoading}
					/>
				</div>

				<div className="form-group">
					<label>
						<input
							type="checkbox"
							id="showLogoutButton"
							checked={showLogoutButton}
							onChange={(e) => setShowLogoutButton(e.target.checked)}
						/>
						Show Logout Button
					</label>
				</div>

				<button
					id="launchButton"
					type="button"
					className="launch-button"
					onClick={handleLaunch}
					disabled={isLoading || !token.trim()}
				>
					{isLoading ? 'Launching...' : 'Launch Reader'}
				</button>
			</div>
		</div>
	);
}

export default PlayerLauncher;
